<template>
  <c-box textAlign="center" class="infinite_scroller">
    <c-text as="span" v-if="loadingMore" data-cy="loadMoreIndicator" color="brand.grayDark">
      {{ $t("productSearch.loadingMore") }}
    </c-text>
  </c-box>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import debounce from "lodash/debounce";
import { CText, CBox } from "@chakra-ui/vue";

export default defineComponent({
  name: "InfiniteScroller",
  components: { CText, CBox },
  props: {
    results: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    resultCount: { type: Number, required: true },
    action: Function as PropType<() => any>,
    loadingMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      debouncedAction: null as any | null,
    };
  },
  mounted() {
    if (this.action) {
      this.debouncedAction = debounce(this.action, 50);
    }

    const loadMore = () => {
      if (this.loadingMore) {
        return true;
      }
      if (this.results.length < this.resultCount) {
        const loadMoreDiv = document.querySelector(".infinite_scroller")!;
        const bounding = loadMoreDiv.getBoundingClientRect();
        if (
          bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
          bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        ) {
          if (this.action) {
            this.debouncedAction();
          }
          return true;
        }
      }
      return false;
    };

    // If the initial amount of items is not enough to fill a large window, load more items until the page is full or all results have been loaded
    const fillPage = window.setInterval(() => {
      if (this.results.length === this.resultCount) {
        window.clearInterval(fillPage);
        return;
      }
      const loadedMore = loadMore();
      if (!loadedMore) {
        window.clearInterval(fillPage);
      }
    }, 500);

    window.onscroll = loadMore;
  },
  beforeDestroy() {
    window.onscroll = () => {};
  },
});
</script>
